<script setup>

import { ref, inject } from 'vue';

import Listbox from 'primevue/listbox';
import Parametre from './Parametre.vue';
import ModaleAjoutParametre from '@/components/modales/ModaleAjoutParametre.vue';

const { parametres } = defineProps({
	parametres: Array
});

const schema = inject('schema');
const selectionSchema = inject('selectionSchema');

const affichageModaleAjoutParametre = ref(false);

function gererAjoutParametre(nomParametre) {
	selectionSchema.value.parametre = schema.value.parametres.find(param => param.nom === nomParametre);
}

</script>

<template>
	<div>
		<div class="entete">
			<label class="titre">Parametres</label>
			<div class="conteneur-boutons">
				<button class="bouton fa-solid fa-plus" @click="affichageModaleAjoutParametre = true" />
			</div>
		</div>
		<Listbox class="liste-parametres" 
		  v-model="selectionSchema.parametre" 
		  :options="parametres"
		  :selectOnFocus="true"
		  :emptyMessage="'Aucun paramètre'"
		  :optionLabel="'nom'"
		  :disabled="!parametres.length">
			<template #option="slotProps">
				<Parametre :parametre="slotProps.option" :selectionne="slotProps.option == selectionSchema.parametre" />
			</template>
		</Listbox>
		<ModaleAjoutParametre 
			v-if="affichageModaleAjoutParametre"
			v-model:visible="affichageModaleAjoutParametre" 
			:parametre="{}"
			:quandCree="gererAjoutParametre" />
	</div>
</template>

<style scoped>

.liste-parametres {
	height: 15vh;
	overflow: auto;
}

.entete {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 2px;
}

</style>